<template>
		<div class="page-ecommerce-products flex">
			<PersonAndPay :sidebarOpen="sidebarOpen" @close="sidebarOpen = false"></PersonAndPay>
			<div class="list scrollable box grow">
				<div class="toggle-filter-box">
					<button @click="sidebarOpen = !sidebarOpen">
						<span v-if="!sidebarOpen">Ver datos de pago</span>
						<span v-if="sidebarOpen">Cerrar datos de pago</span>
					</button>
				</div>
				<div class="title-card card-form card-base card-outline card-shadow--small">
					<span class="invoice_title">$ {{ format(total) }}</span>
					<span class="store_title"><i class="mdi mdi-store"></i> {{ user.branch.razon_social }}</span>
				</div>
					<div class="widget">
						<div class="title">
							<el-input
								class="search-product"
								placeholder="Buscar Producto..."
								v-model="code_product"
								@keyup.native.enter="search_product"
								clearable>
								<i slot="prefix" class="el-input__icon el-icon-goods"></i>
								<el-button slot="append" icon="el-icon-search" @click="search_product"></el-button>
							</el-input>
						</div>
						<div class="content border-bottom">
							<el-row>
								<el-col :span="24" style="background: #fbfbfb;">
									<vue-scroll class="scroller detail">
										<div style="height: 320px;">
											<el-table
												:show-header="false"
												:data="tableData"
												style="">
												<el-table-column type="expand" width= "30">
													<template slot-scope="props">
														<el-row class="wfull detail-more">
															<el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4" class="ph-10">
																<label for="">Descuento</label><el-input placeholder="0%" size="small" v-model="props.row.discount"></el-input>
															</el-col>
															<el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4" class="ph-10">
																<label for="">IVA</label><el-input placeholder="$ 0" size="small" v-model="props.row.iva" disabled></el-input>
															</el-col>
														</el-row>
													</template>
												</el-table-column>
												<el-table-column
													label=""
													width="50">
													<template slot-scope="props">
														<el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
															<el-button 
																type="danger" 
																icon="el-icon-delete" 
																size="mini" 
																circle
																class="btn-delete-circle"
																@click="deleteRow(props.$index, props.row)"></el-button>
														</el-tooltip>
													</template>
												</el-table-column>
												<el-table-column
													label=""
													width="50"
													v-if="innerWidth > 678">
													<template slot-scope="props">
														<div class="image-input">
															<el-image 
																v-if="props.row.url"
																:src="props.row.url" 
																class="avatar" alt="avatar"
																:preview-src-list="props.row.srcList">
															</el-image>
															<el-image 
																v-else
																src="/static/images/products/no-image.png" 
																class="avatar" alt="avatar"
																:preview-src-list="['/static/images/products/no-image.png']">
															</el-image>
														</div>
													</template>
												</el-table-column>
												<el-table-column
													label="Nombre"
													prop="name">
												</el-table-column>
												<el-table-column
													label="Cantidad"
													>
													<template slot-scope="props">
														<div class="col-input">
															<el-input-number size="small" :min="1" v-model="props.row.quantity" @change="calculateTotals(props)"></el-input-number>
														</div>
													</template>
												</el-table-column>
												<el-table-column
													label="Precio"
													:width="(innerWidth < 678) ? 0 : ''"
													>
													<template slot-scope="props" v-if="innerWidth > 678">
														<div class="number-input">
															<label class="total_detail">$ {{props.row.price}}</label>
														</div>
													</template>
												</el-table-column>
												<el-table-column
													label="Total"
													>
													<template slot-scope="props">
														<div class="number-input">
															<label class="total_detail">$ {{props.row.total}}</label>
														</div>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</vue-scroll>
								</el-col>
							</el-row>
						</div>
						<div class="content">
							<el-row>
								<el-col :span="18" style="text-align: end;">
										<div class="totals-text">Subtotal</div>
								</el-col>
								<el-col :span="5">
										<div class="border-bottom totals-values">
											<i class="mdi mdi-currency-usd"></i>
											<span class="total-data">{{ this.format(subtotal) }}</span>
										</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="18" style="text-align: end;">
										<div class="totals-text">IVA</div>
								</el-col>
								<el-col :span="5">
										<div class="border-bottom totals-values">
											<i class="mdi mdi-currency-usd"></i>
											<span class="total-data">{{ this.format(iva) }}</span>
										</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="18" style="text-align: end;">
										<div class="totals-text">
											Descuento 1
										</div>
								</el-col>
								<el-col :span="5">
										<div class="border-bottom totals-values">
											<i class="mdi mdi-currency-usd"></i>
											<span class="total-data">{{ '-' + this.format(discount1) }}</span>
										</div>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="18" style="text-align: end;">
										<div class="totals-text">
											<span class="discount2" @click="showDiscount = true">Descuento 2 <i class="mdi mdi-tooltip-edit"></i></span>
										</div>
								</el-col>
								<el-col :span="5">
										<div class="border-bottom totals-values">
											<i class="mdi mdi-currency-usd"></i>
											<span class="total-data" v-if="showDiscount">
												<el-input 
													type="number" 
													size="mini" 
													placeholder="0.00"
													v-model="discount2" 
													@blur="showDiscount = false"
													@keyup.enter.native="showDiscount = false" 
													:autofocus="true">
												</el-input>
											</span>
											<span class="total-data" v-else>{{ '-' + this.format(discount2) }}</span>
										</div>
								</el-col>
							</el-row>
						</div>
					</div>
			</div>
		</div>
</template>

<script>
import PersonAndPay from '../../../views/apps/pos/PersonAndPay.vue'
import { getUser } from '@/utils/auth'
import { getProductByCode } from '@/api/product'
export default {
	name: 'Pos',
	data () {
		return {
			innerWidth: 0,
			sidebarOpen: false,
			user: getUser(),
			code_product: null,
			subtotal: 0,
			iva: 0,
			discount1: 0,
			discount2: null,
			showDiscount: false,
			total: 0,
			tableData: []
		}
	},
	watch: {
		showDiscount(newVal, oldVal){
			this.calculateTotals()
		}
	},
	computed: {},
	methods: {
		resizeOpenNav() {
      this.innerWidth = window.innerWidth;
    },
		format(number){
			//PASAR INTEGER A FORMATO NUMERO
			return new Intl.NumberFormat().format(number);
		},
		formatN(number){
			// PASAR FORMATO NUMERO A INTEGER
			return (number == null || number == '') ? 0 : parseFloat(_.replace(number.toString(), /\./g, ""))	
		},
		getData(){
			this.tableData = [
				// {
				// 	id: 1,
				// 	url:'/static/images/products/prod1.jpg',
				// 	srcList:['/static/images/products/prod1.jpg'],
				// 	name:'10017012102264 T-SHIRT',
				// 	quantity: 1,
				// 	price: this.format(100000),
				// 	total: this.format(100000),
				// 	discount: null,
				// 	iva: 1500
				// },
			]
		},
		calculateTotals(props){
			// CALCULAR TOTALES
			this.subtotal = 0;
			this.iva = 0;
			this.discount1 = 0;
			
			if (props) {
				var total = this.formatN(props.row.quantity) * this.formatN(props.row.price);
				this.tableData[props.$index].total = this.format(total);
			}
			this.tableData.forEach(elem => {
					this.subtotal += this.formatN(elem.total)
					this.iva += this.formatN(elem.iva)
					this.discount1 += this.formatN(elem.discount)
			});
			this.total = this.subtotal + this.iva - this.discount1 - this.discount2;
		},
		search_product(){
			console.log(this.code_product);
			getProductByCode(this.code_product).then(({ data }) => {
				console.log('data: ', data);
				
			}).catch(function (error){
				this.$message.error('Error registrar cliente.')
        console.log(error)
			})
			
		},
	},
	created() {
	},
	mounted() {
		let me = this
		this.resizeOpenNav();
		window.addEventListener("resize", this.resizeOpenNav);
		setTimeout(() => {
			me.getData();
			me.calculateTotals();
		}, 1000);
	},
	beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);
  },
	components:{
		PersonAndPay
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';
@import '../../../assets/scss/app/pos';

.el-input-number{
	width: 100%;
}
.remove-col{
	visibility: hidden !important;
}
@media (min-width: 1400px) {
	.btn-delete-circle{
		width: 90% !important;
	}
}
</style>


